import { Component, type ReactNode } from "react";

/** Evita a "tela branca": se uma tela falhar ao desenhar, o menu continua e aparece um aviso com a opção de recarregar. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { erro: Error | null }> {
  state = { erro: null as Error | null };
  static getDerivedStateFromError(erro: Error) { return { erro }; }
  componentDidCatch(erro: Error) { console.error("Falha ao desenhar a tela:", erro); }
  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div className="card" role="alert" style={{ maxWidth: 560 }}>
        <h3 style={{ fontSize: 16, marginBottom: 6 }}>Não foi possível mostrar esta tela</h3>
        <p className="muted" style={{ marginTop: 0 }}>Seus dados não foram alterados. Atualize a página; se continuar, envie a mensagem abaixo ao suporte.</p>
        <pre className="small" style={{ whiteSpace: "pre-wrap", margin: "0 0 12px" }}>{this.state.erro.message}</pre>
        <button className="btn primary" onClick={() => location.reload()}>Recarregar</button>
      </div>
    );
  }
}
